<template>
  <form class="form-inline admin-search-form mb-3" @submit.prevent="search">
    <input ref="admin-search" class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" :value="searchText"
      @input="$emit('searched', $event, $event.target.value)">
    <i @click="search" class="fas fa-search ml-2 ml-md-0 cursor-pointer fa-lg"></i>
  </form>
</template>

<script>
  export default {
    props: {
      searchText: String
    },
    data() {
      return {
        value: this.searchText
      }
    },
    mounted() {
      if (this.searchText) this.$refs['admin-search'].focus()
    },
    methods: {
      search(e) {
        this.$emit('searched', e, this.value)
      }
    },
    watch: {
      searchText(val) {
        this.value = val;
      }
    }
  }
</script>
